// 🔹 Create ContactPopup.js (reusable popup)
import React, { useEffect } from "react";
import ContactForm from "../components/ContactForm";
import "../styles/ContactPopup.css";

function ContactPopup({ show, onClose }) {
  useEffect(() => {
    if (show && window.innerWidth < 768) {
      const el = document.getElementById("contact-form-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        el.classList.add("highlight-contact-form");
        setTimeout(() => {
          el.classList.remove("highlight-contact-form");
        }, 3000);
      }
    }

    if (show) {
        document.body.style.overflow = "hidden";  // Disable background scroll when popup is open
      } else {
        document.body.style.overflow = "";        // Restore background scroll when popup closes
      }
    
      // Cleanup on unmount
      return () => {
        document.body.style.overflow = "";
      };
  }, [show]);

  if (!show) return null;

  return (
    <div className="popup-overlay d-flex align-items-center justify-content-center">
      <div className="container">
        <div className="row justify-content-center">
          {/* Popup Layout */}
          <div className="col-lg-5 col-md-7 col-sm-11 bg-white rounded shadow p-0 position-relative">
            <button
              className="popup-close"
              onClick={onClose}
              style={{ right: "10px", top: "10px", left: "auto", position: "absolute", zIndex: 10 }}
            >
              &#10006;
            </button>

            <div
              style={{
                backgroundImage: `url(/images/popup-bg.webp)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                padding: "30px 20px",
                textAlign: "center",
              }}
            >
              <h5
                style={{
                  fontWeight: "bold",
                  color: "#fff",
                  fontSize: "clamp(1.5rem, 3vw, 2rem)",
                  marginTop: "15px"
                }}
              >
                BUY AT LOWEST WHOLESALE RATES ON 5,000+ PRODUCTS
              </h5>
              <p
                style={{
                  color: "#f1f1f1",
                  fontSize: "clamp(1rem, 2vw, 1.2rem)",
                }}
              >
                CHOOSE THE ONE THAT SUITS YOU BEST!
              </p>
            </div>

            <div
              id="contact-form-section"
              className="popup-form-container px-0 py-0"
            >
              <ContactForm onSuccess={onClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPopup;
